/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Beweegthema_Steunendzwaaien3Inputs */

const nl_enums_beweegthema_steunendzwaaien3 = /** @type {(inputs: Enums_Beweegthema_Steunendzwaaien3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steunend zwaaien`)
};

/**

* @param {Enums_Beweegthema_Steunendzwaaien3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_beweegthema_steunendzwaaien3 = /** @type {((inputs?: Enums_Beweegthema_Steunendzwaaien3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Beweegthema_Steunendzwaaien3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_beweegthema_steunendzwaaien3(inputs)
});
export { enums_beweegthema_steunendzwaaien3 as "enums.Beweegthema.SteunendZwaaien" }